import PropTypes from 'prop-types';
import {
  React,
  useState } from 'react';

import * as S from './confirm-purchase.module.scss';

import { ModalWrapper } from '../modal-wrapper';

import { Message } from '../../common/message';

import { useGlobalCtx } from '../../../context/ctx-hook';
import * as Actions from '../../../context/ctx-actions';

import * as NetworkCalls from '../../../network/network-calls';
import { SkuProductRow } from '../../pages/subscriptions/unified-sub-tile/sku-single-row';

import { MODALS }         from '../../../helpers/constants/state-constants';
// import { getARLegalText } from '../../../helpers/constants/constants';
import { LegalArText } from '../../common/legal-ar-text';

import * as UserSelectors      from '../../../context/selectors/user-selectors';
import { getPaymentMethods } from '../../logged-in-template/get-site-data';

const getModalTitlebyAction = (action) => {
  if(action === 'CREATE') {
    return 'Confirm Order';
  } else if(action === 'UPGRADE') {
    return 'Confirm Upgrade';
  } else if(action === 'DOWNGRADE') {
    return 'Confirm Downgrade';
  } else {
    return 'Confirm';
  }
};

const ConfirmPurchase = ( {onClose, ctx: {product, plan, sku, nonce, action} }) => {
  const {globalDispatch, state} = useGlobalCtx();
  const [hasErr, setHasErr] = useState(false);
  const PRODUCT_PAYMENT = UserSelectors.getProductsPaymentMethod(product , state);
  const HAS_ACH_PAYMENT = PRODUCT_PAYMENT ? PRODUCT_PAYMENT?.paymentMethodType === 'ACH' : false;

  const handleBackToPayment = () => {

    if(HAS_ACH_PAYMENT) {
      globalDispatch(Actions.mergeMainStateObj({
        isDisabled: false,
        modal:      {
          type:       MODALS.CHANGE_PLAN,
          ctx:  { product },

          isLoading:  true,
          hasError: false,
          isDisabled: false
        }
      }));
    } else {
      globalDispatch(Actions.mergeMainStateObj({
        isDisabled: false,
        modal:      {
          type:       MODALS.UPDATE_PAYMENT,
          ctx: {
            product: product,
            plan: plan,
            bmSku: sku,
            paymentOnly: false,
            isPurchaseFlow: true
          },
          isLoading:  true,
          hasError: hasErr,
          isDisabled: false
        }
      }));
    }

  };

  const handlePurchase = async () => {
    if(hasErr) {
      setHasErr(false);
    }


    try {
      globalDispatch(Actions.setCtxField('isDisabled', true));

      if(nonce) {
        const { paymentData } = await NetworkCalls.callUpdatePaymentNonce(nonce, {
          productLineUriName:   product
        });
        const paymentResp = await NetworkCalls.callGetPaymentMethods();
        globalDispatch(Actions.mergeMainStateObj({
          payMethods: paymentResp.data,
          payment: getPaymentMethods(paymentResp.data)
        }));
      }

      const {data} = await NetworkCalls.callPostChangeTier(plan, sku, action);
      globalDispatch(Actions.mergeSubscriptionData(product, data.postState));

      onClose();
      globalDispatch(Actions.setCtxField('isDisabled', false));


    } catch (err) {
      console.log('ach purchase error', err);
      console.log(err.response);

      // Checks ACH network errors
      const checkBtNetErr = err.response?.data?.errors[0]?.extData?.achVerificationProcessorResponseCode;
      if (checkBtNetErr) {
        const btNetMsg = err.response?.data?.errors[0]?.detail;
        globalDispatch(Actions.mergeMainStateObj({
          payment: {
            hasBraintreeNetError: true,
            btErrMsg: btNetMsg
          }
        }));
      // Otherwise check for general braintree errrors
      } else if (err?.name === 'BraintreeError') {
        globalDispatch(Actions.mergeMainStateObj({
          payment: {
            hasBraintreeError: true
          }
        }));
      }
      setHasErr(true);
      globalDispatch(Actions.setCtxField('isDisabled', false));

      handleBackToPayment();
    }
  };

  return (
    <ModalWrapper heading={getModalTitlebyAction(action)} onClose={onClose}>
      <div className={S.modalBody}>
        <SkuProductRow sku={sku} />

        <div className={S.modalBtm}>
          {hasErr &&
            <Message
              title={['That didn\'t work.']}
              messages={[]}
              type={'GENERIC_ERROR'}
            />
          }

          {action !== 'DOWNGRADE' &&
            <LegalArText
              btnText={'Confirm Order'}
              chargeType={'purchase'}
            />
          }

          <div className={S.btnRow}>
            <button
              type="button"
              onClick={handleBackToPayment}
              className={S.ctaBtnInvert}
              disabled={state.isDisabled}
            >Go Back</button>


            <button
              type="button"
              onClick={handlePurchase}
              className={S.ctaBtn}
              disabled={state.isDisabled}
            >
              {action === 'DOWNGRADE' ? 'Downgrade Plan' : 'Confirm Order'}
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

ConfirmPurchase.propTypes = {
  onClose:  PropTypes.func.isRequired,
  ctx:     PropTypes.object,
};

export { ConfirmPurchase };